import { createActionFactory } from '../../common/redux';

const { createAction } = createActionFactory('Chat => ');

const performChatCommand = createAction('perform chat command', (command, payload) => ({ command, payload }));
const reset = createAction('reset');

export default {
  performChatCommand,
  reset,
};
